import React, { useState, useEffect } from 'react';
import { useAuth } from '../Auth/AuthContext';
import { useRegions } from '../../context/RegionContext';
import { FaSignOutAlt, FaUserCircle, FaMapMarkerAlt } from 'react-icons/fa';
import { AuthProvider } from '../Auth/AuthContext';
import { Link, useLocation } from "react-router-dom";
import { FaUsers, FaUserFriends } from "react-icons/fa";
import { MdSecurity } from "react-icons/md";
import { FaKey } from "react-icons/fa";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { CgMenuGridO } from "react-icons/cg";
import { SiGoogleads } from "react-icons/si";

const Navbar = () => {
  const { user, logout, permissions, getPermittedRegions, selectedRegion, updateSelectedRegion } = useAuth();
  const { regions, loading } = useRegions();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const permittedRegions = getPermittedRegions('sourcing_lead', 'read');
  
  // Filter available regions based on permissions
  const availableRegions = regions.filter(region => 
    permittedRegions.includes(region.id.toString())
  );

  // Set initial selected region if not set and regions are available
  useEffect(() => {
    if (availableRegions.length > 0 && !availableRegions.find(r => r.id.toString() === selectedRegion)) {
      updateSelectedRegion(availableRegions[0].id.toString());
    }
  }, [availableRegions, selectedRegion, updateSelectedRegion]);

  const navItems = [
    { path: "/", label: "Dashboard", icon: null },
    {
      path: "/potential-leads",
      label: "Potential Leads",
      icon: <SiGoogleads className="w-5 h-5" />,
    },
    {
      path: "/lead-form",
      label: "Lead Form",
      icon: <FaUsers className="w-5 h-5" />,
    },
    {
      path: "/pending-registration",
      label: "Pending Registration",
      icon: <FaUserFriends className="w-5 h-5" />,
    },
    {
      path: "/pending-training",
      label: "Pending Training",
      icon: <FaUserFriends className="w-5 h-5" />,
    },
  ];

  return (
    <nav className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* <div className="flex items-center">
            <button
              onClick={toggleSidebar}
              className="fixed top-4 left-4 sm:hidden z-50 p-2 rounded-full
                    bg-gray-900
                    shadow-lg
                    hover:bg-gray-800 transition-colors"
            >
              {isSidebarOpen ? (
                <AiOutlineCloseCircle size={24} className="text-white" />
              ) : (
                <CgMenuGridO size={24} className="text-white" />
              )}
            </button>
          </div> */}

          <div className="flex items-center">
            <h1 className="hidden md:block text-xl font-semibold text-gray-800">
              {navItems.find((item) => item.path === location.pathname)
                ?.label || "Dashboard"}
            </h1>
          </div>

          <div className="flex items-center">
            <h1 className="block md:hidden text-xl font-semibold text-gray-800">
              {navItems.find((item) => item.path === location.pathname)
                ?.label || "Dashboard"}
            </h1>
          </div>

          <div className="flex items-center space-x-6">
            {/* Region Filter */}
            {!loading && availableRegions.length > 0 && (
              <div className="flex items-center space-x-2 bg-gray-50 px-3 py-2 rounded-lg">
                <FaMapMarkerAlt className="text-gray-500" />
                <select
                  value={selectedRegion || ''}
                  onChange={(e) => {
                    updateSelectedRegion(e.target.value);
                  }}
                  className="text-sm font-medium text-gray-700 bg-transparent border-none focus:outline-none focus:ring-0 cursor-pointer"
                >
                  {availableRegions.map((region) => (
                    <option key={region.id} value={region.id.toString()}>
                      {region.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <button
              onClick={logout}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg
                text-white bg-pink-500 hover:bg-pink-600 
                transition-all duration-200 ease-in-out
                focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-400
                shadow-sm hover:shadow-md active:shadow-inner"
            >
              <FaSignOutAlt className="mr-2" />
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
